<template>
  <el-container>
    <el-header>
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="queryParam.SearchField">
            <el-option value="ActualTime" :label="`${stockTypeDesc}库时间`" />
            <el-option value="CreatedAt" label="创建时间" />
          </el-select>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            class="date-range"
            range-separator="至"
            :editable="false"
            clearable
            @change="handleQuery"
          />
        </el-form-item>
        <el-form-item label="商品状态">
          <el-select v-model="queryParam.StockStatus" clearable placeholder="请选择" @change="handleQuery">
            <el-option :value="null" label="全部" />
            <el-option :value="0" :label="`待${stockTypeDesc}库`" />
            <el-option :value="1" :label="`部分${stockTypeDesc}库`" />
            <el-option :value="2" label="已完成" />
          </el-select>
        </el-form-item>
        <el-form-item :label="`${stockTypeDesc}库类型`">
          <el-select v-model="queryParam.OrderType" clearable placeholder="请选择" @change="handleQuery">
            <el-option :value="null" label="全部" />
            <el-option :value="1" label="采购" />
            <el-option v-if="stockType == 'in'" :value="2" label="退货" />
            <el-option :value="3" label="手动" />
          </el-select>
        </el-form-item>
        <el-form-item label="供应商">
          <el-input v-model="queryParam.SupplierName" clearable placeholder="请输入供应商" @change="handleQuery" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button type="default" @click="reset">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="default" @click="handleExport" :loading="batchExportLoading">导出Excel</el-button>
          <el-button type="success" @click="handleShowForm('purchase')">{{ stockType == 'in' ? '采购入库' : '采购退货' }}</el-button>
          <el-button v-if="stockType == 'in'" type="warning" @click="handleShowForm('return')">销售退货</el-button>
          <el-button type="primary" @click="handleShowForm('manual')">手动{{ stockTypeDesc }}库</el-button>
          <el-button type="warning" @click="handleShowForm('scan')">扫码{{ stockTypeDesc }}库</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main>
      <grid-table
        ref="gridTable"
        :showIndexColumn="false"
        :showCheckboxColumn="false"
        :showLastEmptyColumn="false"
        :showPagination="true"
        :tableConfig="tableConfig"
        @rowOperation="handleRowOperation"
      >
        <template slot="Quantity" slot-scope="{ params }">
          {{ params.row.OrderType == 1 ? params.row.Quantity : '' }}
        </template>
      </grid-table>
    </el-main>
    <in-out-stock-form ref="inOutStockForm" @refresh="handleQuery" />
  </el-container>
</template>

<script>
import { exportFile } from '@/api/base'
import { getDate } from '@/utils/tool'
import InOutStockForm from './components/InOutStockForm.vue'
import dayjs from 'dayjs'

export default {
  name: 'InOutStock',
  props: {
    stockType: { type: String, default: 'out' },
  },
  components: {
    InOutStockForm,
  },
  mounted() {
    this.$nextTick(async () => {
      this.queryParam.StockType = this.stockType == 'in' ? 1 : 2
      const startOfMonth = dayjs().startOf('month').format('YYYY-MM-DD')
      const today = getDate()
      this.dateRange = [startOfMonth, today]
      this.handleQuery()
    })
  },
  data() {
    return {
      dateRange: [],
      queryParam: {
        SearchField: 'CreatedAt',
        SupplierName: '',
        StockStatus: null,
        StockType: 1, //入库
        OrderType: null,
        StartTime: '',
        EndTime: '',
      },
      batchExportLoading: false,
      type: '',
    }
  },
  computed: {
    stockTypeDesc() {
      return this.stockType == 'in' ? '入' : '出'
    },
    tableConfig() {
      return {
        url: '/api/wms/stock/getStockOrderPageList',
        rowKey: 'ID',
        columns: [
          {
            label: '单据编号',
            prop: 'OrderNo',
            type: 'text',
            width: '220px',
          },
          {
            label: `${this.stockTypeDesc}库类型`,
            prop: 'OrderTypeText',
            type: 'text',
            width: '140px',
          },
          {
            label: '状态',
            prop: 'StockStatusText',
            type: 'text',
            width: '140px',
          },
          {
            label: '仓库',
            prop: 'WName',
            type: 'text',
            isHidden: !this.$store.state.routes.systemSetting.MultiWarehouse,
            width: '180px',
          },
          {
            label: '供应商',
            prop: 'SupplierName',
            type: 'text',
          },
          {
            label: '采 / 退日期', //采购或退货日期
            prop: 'SourceOrderTime',
            type: 'text-datetime',
            dateFormat: '<strong>yyyy-MM-dd</strong>',
            width: '180px',
            isHidden: this.stockType != 'in',
          },
          {
            label: '采 / 退数量',
            prop: 'Quantity',
            type: 'custom-operation',
            width: '150px',
          },
          {
            label: `${this.stockTypeDesc}库数量`,
            prop: 'ActualQuantity',
            type: 'text',
            width: '150px',
          },
          {
            label: '创建时间',
            prop: 'CreatedAt',
            type: 'text-datetime',
            dateFormat: '<strong>yyyy-MM-dd</strong> HH:mm',
            width: '180px',
          },
          {
            label: `${this.stockTypeDesc}库时间`,
            prop: 'ActualTime',
            type: 'text-datetime',
            dateFormat: '<strong>yyyy-MM-dd</strong> HH:mm',
            width: '180px',
          },
          {
            type: 'operation',
            label: '操作',
            prop: 'Operation',
            width: '100px',
            buttons: [{ type: 'primary', label: '详情', method: 'handleShowDetail' }],
          },
        ],
      }
    },
  },
  methods: {
    async handleQuery() {
      this.queryParam.StartTime = ''
      this.queryParam.EndTime = ''
      if (this.dateRange && this.dateRange.length > 0) {
        this.queryParam.StartTime = this.dateRange[0]
        this.queryParam.EndTime = this.dateRange[1]
      }
      await this.$refs.gridTable.fetchData(false, null, this.queryParam)
    },
    reset() {
      this.queryParam.SupplierName = ''
      this.queryParam.StockStatus = null
      this.queryParam.OrderType = null
      this.handleQuery()
    },
    async handleExport() {
      let param = {}
      var that = this
      param = { ...this.queryParam }
      this.batchExportLoading = true
      const today = dayjs().startOf('day').format('YYYYMMDD')
      const { data } = await exportFile('/api/wms/stock/exportStockOrder', param)
      const blob = new Blob([data.Blob], { type: 'application/vnd.ms-excel' })
      var a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = `${this.stockTypeDesc}库单_${today}.xls`
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
      that.batchExportLoading = false
    },
    handleShowForm(orderType) {
      this.$refs.inOutStockForm.show(this.stockType, orderType)
    },
    handleRowOperation(row, index, method) {
      this.$options.methods[method](this, row)
    },
    handleShowDetail(_this, row) {
      _this.$refs.inOutStockForm.show(row.StockType, row.OrderType, row.ID)
    },
  },
}
</script>

<style lang="scss" scoped>
.el-header {
  height: auto !important;
}

.el-form {
  padding: 8px 8px 0;
}

.el-select {
  width: 100px;
}

.el-date-editor {
  width: 215px;
}

.el-input {
  width: 150px;
}
</style>
